import { Footprints, Globe, Instagram, MessageCircle, Phone, Store, UserRoundPlus, CircleHelp } from "lucide-react";

// Pipeline stages in board order. `tone` drives the column tint, dot, and add button.
export const STAGES = [
  { key: "NEW", label: "New", tone: "neutral" },
  { key: "QUALIFIED", label: "Qualified", tone: "terracotta" },
  { key: "DESIGNING", label: "Designing", tone: "violet" },
  { key: "QUOTATION", label: "Quotation", tone: "blue" },
  { key: "WON", label: "Won", tone: "green" },
  { key: "LOST", label: "Lost", tone: "red" },
];

export const STAGE_LABEL = Object.fromEntries(STAGES.map((s) => [s.key, s.label]));

export const STAGE_TONE = {
  neutral: {
    column: "bg-secondary/60 border-border",
    dot: "bg-muted-foreground/60",
    add: "border-border text-foreground/80 hover:bg-card",
    pill: "bg-secondary text-foreground/80",
  },
  terracotta: {
    column: "bg-accent/[0.06] border-accent/15",
    dot: "bg-accent",
    add: "border-accent/40 text-accent hover:bg-accent/5",
    pill: "bg-accent/10 text-accent",
  },
  violet: {
    column: "bg-[hsl(262_55%_60%/0.07)] border-[hsl(262_55%_60%/0.18)]",
    dot: "bg-[hsl(262_55%_60%)]",
    add: "border-[hsl(262_55%_60%/0.45)] text-[hsl(262_45%_52%)] hover:bg-[hsl(262_55%_60%/0.06)]",
    pill: "bg-[hsl(262_55%_60%/0.12)] text-[hsl(262_45%_52%)]",
  },
  blue: {
    column: "bg-[hsl(212_70%_55%/0.07)] border-[hsl(212_70%_55%/0.18)]",
    dot: "bg-[hsl(212_70%_55%)]",
    add: "border-[hsl(212_70%_55%/0.45)] text-[hsl(212_60%_45%)] hover:bg-[hsl(212_70%_55%/0.06)]",
    pill: "bg-[hsl(212_70%_55%/0.12)] text-[hsl(212_60%_45%)]",
  },
  green: {
    column: "bg-success/[0.06] border-success/15",
    dot: "bg-success",
    add: "border-success/40 text-success hover:bg-success/5",
    pill: "bg-success/10 text-success",
  },
  red: {
    column: "bg-danger/[0.05] border-danger/15",
    dot: "bg-danger",
    add: "border-danger/40 text-danger hover:bg-danger/5",
    pill: "bg-danger/10 text-danger",
  },
};

export const stageTone = (key) => STAGE_TONE[STAGES.find((s) => s.key === key)?.tone || "neutral"];

export const SOURCES = [
  { value: "Website", icon: Globe },
  { value: "Call", icon: Phone },
  { value: "Showroom", icon: Store },
  { value: "Walk-in", icon: Footprints },
  { value: "Referral", icon: UserRoundPlus },
  { value: "Instagram", icon: Instagram },
  { value: "WhatsApp", icon: MessageCircle },
];

// Older enquiries may carry free-text sources in any case; match loosely.
export function sourceMeta(source) {
  if (!source) return null;
  const hit = SOURCES.find((s) => s.value.toLowerCase().replace(/[^a-z]/g, "") === source.toLowerCase().replace(/[^a-z]/g, ""));
  return hit || { value: source, icon: CircleHelp };
}

export const PROPERTY_TYPES = [
  "1 BHK Apartment",
  "2 BHK Apartment",
  "3 BHK Apartment",
  "4 BHK Apartment",
  "Villa",
  "Independent House",
  "Office Space",
  "Retail Store",
];

export const propertyLine = (e) => [e.propertyType, e.city].filter(Boolean).join(", ");
